import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    includeAllOption?: boolean;
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodiesDropdown({ form, fieldName, value, setValue, includeAllOption = true, zIndex, disabled, required, labelFontSize = 16, labelStyle, viewStyle, label }: Props) {
    const [selectableActingBodies, setSelectableActingBodies] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodies() {
        try {
            const actingBodies = await dispatchService.getActingBodies();
            setSelectableActingBodies([
                ...(includeAllOption ? [{ value: 0, label: translate('masculineAll') }] : []),
                ...actingBodies.map((actingBody) => {
                    return {
                        value: actingBody.id,
                        label: actingBody.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);
    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('actingBody')}
            items={selectableActingBodies}
            multiple={false}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('actingBody')}
                items={selectableActingBodies}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelFontSize={labelFontSize}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}

export default ActingBodiesDropdown;
